<div class="popup" *ngIf="isOpen" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <span class="close-btn" (click)="closePopup()">×</span>
      <img [src]="imageSrc" alt="Popup Image" />
    </div>
  </div>
  